import { render, staticRenderFns } from "./addIncomeType.vue?vue&type=template&id=6582b059&scoped=true&"
import script from "./addIncomeType.vue?vue&type=script&lang=js&"
export * from "./addIncomeType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6582b059",
  null
  
)

export default component.exports